export const SET_ACT_PROPERTY = 'SET_ACT_PROPERTY';
export const ACT_GET_ACT = 'ACT_GET_ACT';
export const SIGN_INIT_GUID = 'SIGN_INIT_GUID';
export const ACT_ERROR = 'ACT_ERROR';
export const ACT_CMS = 'ACT_CMS';
export const ACT_SAVE_DATA = 'ACT_SAVE_DATA';
export const ACT_CONFIRM_IDENTITY = 'ACT_CONFIRM_IDENTITY';
export const ACT_GET_CATALOG = 'ACT_GET_CATALOG';
export const ACT_GET_DATA_BY_PARTNER_AND_STEP = 'ACT_GET_DATA_BY_PARTNER_AND_STEP';
export const UI_UPDATE_FROM_PARTNER = 'UI_UPDATE_FROM_PARTNER';
export const SET_ACT_CHECKLIST_ITEM = 'SET_ACT_CHECKLIST_ITEM';
export const SEND_SIGN = 'SEND_SIGN';
export const END_SIGN = 'END_SIGN';
export const CANCEL_ACT = 'CANCEL_ACT';
export const VALIDATE_DOCUMENT = 'VALIDATE_DOCUMENT';
export const GET_DOCUMENTS = 'GET_DOCUMENTS';
